module.exports = __webpack_public_path__ + "static/img/online_pic5.efa8d4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_pic5.jpg
// module id = MXjC
// module chunks = 21